module.exports = __webpack_public_path__ + "static/media/99.2837d262.jpg";